export default class Chambre{
    constructor(element){
        console.log("allo");
        this.element = element;
        this.init();
    }

    init(){
        this.element.querySelector('.button__more').addEventListener('click', this.toggleInfo.bind(this));
    }

    toggleInfo() {
        this.element.querySelector('.more__info').classList.toggle('is-active');
    }

}